import { initializeIcons } from '@fluentui/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import Chat from './pages/chat/Chat'
import Feedback from './pages/feedback/Feedback'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
import Stats from './pages/stats/Stats'
import { AppStateProvider } from './state/AppProvider'

initializeIcons()

export default function App() {
  return (
    <AppStateProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Chat />} />
            <Route path="/stats" element={<Stats />} /> 
            <Route path="/feedback" element={<Feedback />} /> 
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </HashRouter>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
